import { useMemo } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';
import S3 from 'aws-sdk/clients/s3';
import config from 'aws-exports';

async function getS3Client() {
  const { credentials } = await fetchAuthSession();
  const { accessKeyId, secretAccessKey, sessionToken } = credentials;
  return new S3({ region: config.Storage.region, credentials: { accessKeyId, secretAccessKey, sessionToken } });
}

const useStorage = ({ onUpload }) => {
  return useMemo(
    () => ({
      upload: async (path, file) => {
        const s3Client = await getS3Client();
        await s3Client.upload({ Bucket: config.Storage.bucket, Key: path, Body: file }).promise();
        onUpload && onUpload(path);
      },
      download: async (path, secondsBeforeExpire = 86400) => {
        const s3Client = await getS3Client();
        const url = s3Client.getSignedUrl('getObject', {
          Key: path,
          Bucket: config.Storage.bucket,
          Expires: secondsBeforeExpire
        });
        window.open(url, '_blank');
      }
    }),
    [onUpload]
  );
};

export default useStorage;
